// extracted by css-extract-rspack-plugin
export default {"stickyHeaderCell":"bOJP1xpU8su70Vbu","emphasized":"X2CbUgR4560eZ8A0","mediumScreenCell":"tzXy5_Uc2eeJoR1c"};